<template lang="pug">
#court
  .main_container.container
    .row.pt-5
      .col-md-7.pic.text-center.text-md-right
        img(v-if="court.photo", :src="court.photo.image")
      .col-md-5(
        :style="{ minHeight: height + 'px' }",
        v-resize="onResize",
        ref="mapWrapper"
      )
        GmapMap.map(
          :style="{ width: width + 'px', height: height + 'px' }",
          v-if="this.court.lat && this.court.lng",
          :zoom="17",
          :center="latlng"
        )
          GmapMarker(:position="latlng")
    .row
      .col
        h2 {{ court.name }}
    .row
      .col-md-6
        h6
          span
            font-awesome-icon.icon(:icon="['fas', 'map-marker-alt']") 
            | 位置資訊
        p {{ court.address }}
        h6
          span
            font-awesome-icon.icon(:icon="['fab', 'youtube']") 
            | 影片
        a(v-if="court.video_link", :href="court.video_link") 影片連結
      .col-md-6
        h6
          span
            font-awesome-icon.icon(:icon="['fas', 'map-signs']") 
            | 交通資訊
        pre {{ court.traffic_information }}
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import { getCourtDetail } from "@/api/web_content";

export default {
  name: "Court",
  components: {
    "custom-footer": CustomFooter,
  },
  data() {
    return {
      width: 0,
      height: 0,
      court: {},
    };
  },
  mounted() {
    this.width = this.$refs.mapWrapper.clientWidth - 30;
    this.height = this.$refs.mapWrapper.clientWidth * 0.6;
  },
  computed: {
    latlng() {
      if (this.court.lat && this.court.lng) {
        return {
          lat: parseFloat(this.court.lat),
          lng: parseFloat(this.court.lng),
        };
      }
      return { lat: 25.0325917, lng: 121.5624999 };
    },
  },
  created() {
    this.getCourtDetail(this.$route.query.id);
  },
  methods: {
    getCourtDetail(id) {
      getCourtDetail(id).then((response) => {
        this.court = response.data;
      });
    },
    onResize({ width }) {
      this.width = width - 30;
      this.height = width * 0.6;
    },
  },
};
</script>

<style scoped lang="scss">
#court {
  background-color: $color_bg_white;
}

a {
  color: $color_water_blue;
}

.container {
  padding-bottom: 50px;
}

.pic {
  height: fit-content;
  width: 100%;
}
.map {
  // width: 100%;
  // height: 100%;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.pic {
  img {
    height: auto;
    width: 100%;
  }
}

h2 {
  margin-top: 40px;
  color: $c-text;
}

h6 {
  margin-top: 20px;
  color: $c-text;
}

p {
  margin-top: 10px;
  color: $c-text;
}

a {
  margin-top: 10px;
}

.icon {
  margin-right: 5px;
  color: $c-text;
}

@media (max-width: 767px) {
  .locations {
    clear: both;
    float: left;
  }
}
</style>
